<template>
  <div>
    <Modal title="Add A Contact" :open.sync="showCreateContactModal">
      <div class="p-6">
        <contact-form mode="create" @success="contactCreated" />
      </div>
    </Modal>

    <div class="p-6 text-center text-gray-500 border border-gray-300 rounded bg-gray-50" v-if="contacts.meta.total < 1">
      <div>You have no contacts.</div>
      <button type="button" @click="showCreateContactModal = true" class="mt-4 btn btn-secondary btn-sm">
        Create Contact
      </button>
    </div>
    <div v-else>
      <div class="h-48 p-1 overflow-x-visible overflow-y-auto border border-gray-300 rounded">
        <label class="flex items-center px-1 py-2 border-0 cursor-pointer" v-for="contact in contacts.data" :key="contact.id">
          <toggle 
            :value="isInArray(contact.id)" 
            :name="contact.id.toString()" 
            @change="toggleContact(contact)"
            class="mb-0 mr-3" />
          <div class="leading-none">
            <div class="mr-2">{{ contact.name }} </div>
            <small class="text-gray-500" v-html="type === 'email' ? contact.email : contact.cellphone"></small>
          </div>
        </label>
      </div>
      <button type="button" @click="showCreateContactModal = true" class="mt-3 btn btn-secondary btn-sm">
        Add A Contact
      </button>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import ContactForm from '@/views/contacts/ContactForm'

  export default {
    name: 'ContactToggle',

    components: {
      ContactForm
    },

    created () {
      this.getContacts()
      this.$store.subscribeAction((action, state) => {
        if (action.type === 'publishEvent' && action.payload === 'updateContacts') {
          this.getContacts()
        }
      })
    },

    props: {
      parent: {
        type: Object
      },

      type: {
        type: String
      }
    },

    computed: {
      ...mapState(['event']),

      options () {
        return this.contacts.map(contact => contact.id)
      },

      contactType () {
        return this.type + 's'
      }
    },

    data () {
      return {
        loading: true,
        contacts: {
          meta: {},
          data: []
        },
        showCreateContactModal: false
      }
    },

    methods: {
      getContact (id) {
        return this.contacts.filter((contact) => { return contact.id === id })[0]
      },

      isInArray (id) {
        return this.parent[this.contactType].some(contact => contact.id === id)
      },

      toggleContact (contact) {
        this.$emit('toggle', this.type, contact)
      },

      async getContacts () {
        try {
          const { data } = await this.$api.get(`account/${this.$route.params.account}/contacts`)
          this.contacts = data.contacts
          this.loading = false
        } catch (error) {
          console.error(error)
        }
      },

      contactCreated () {
        this.$store.dispatch('publishEvent', 'updateContacts')
        this.showCreateContactModal = false
      }
    }
  }
</script>